<script setup lang="ts">
import { EmbedDataset as ModuleEmbedDataset } from "@piveau/piveau-hub-ui-modules";
import { useRobotsMetaOverride } from "@/composables/useRobotsMetaOverride";

useRobotsMetaOverride("noindex, nofollow");
</script>

<template>
  <ModuleEmbedDataset />
</template>